import { useState } from "react";
import ModalNotificacion from "./ModalNotificacion";
import styles from "./ContactForm.module.css";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalTipo, setModalTipo] = useState("success");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch("send.php", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData),
    });

    const result = await response.text();
    if (result === "success") {
      setModalTipo("success");
      setModalMessage("Mensaje enviado correctamente.");
      setFormData({ name: "", email: "", message: "" });
    } else {
      setModalTipo("error");
      setModalMessage("Hubo un error al enviar. Intenta más tarde.");
    }
    setModalVisible(true);
  };

  return (
    <>
      <div className={styles.contactContainer}>
        <div className={styles.info}>
          <h3>Contacto</h3>
          <p>
            <strong>Dirección:</strong><br />
            Av del Golf 1805, Nordelta
          </p>
          <p>
            <strong>Celular:</strong><br />
            54 9 11 5317 5146
          </p>
          <p>
            <strong>Mail:</strong><br />
            <a href="mailto:estudio@devivoyasociados.com.ar">
              estudio@devivoyasociados.com.ar
            </a>
          </p>
        </div>
        <form className={styles.form} onSubmit={handleSubmit}>
          <label>
            <input
              placeholder="Nombre *"
              name="name"
              type="text"
              required
              onChange={handleChange}
              value={formData.name}
            />
          </label>
          <label>
            <input
              placeholder="Email *"
              name="email"
              type="email"
              required
              onChange={handleChange}
              value={formData.email}
            />
          </label>
          <label>
            <textarea
              placeholder="Mensaje *"
              name="message"
              required
              onChange={handleChange}
              value={formData.message}
            />
          </label>
          <button type="submit">Enviar</button>
        </form>
      </div>

      <ModalNotificacion
        mensaje={modalMessage}
        visible={modalVisible}
        tipo={modalTipo}
        onClose={() => setModalVisible(false)}
      />
    </>
  );
}
